
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import { deserialize, getResourceCollectionFromContext } from "next-drupal";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Pager from "components/Pager";
import PageHeader from "components/PageHeader";
import Meta from "components/Meta";
import NodePublicationList from "components/Publication/NodePublicationList";
import useTranslation from "next-translate/useTranslation";
import { LISTS, getMeta } from "lib/getMeta";

export const NODE_PER_PAGE = 8;

export default function PublicationListIndexPage({
  globals,
  meta,
  nodes,
  page,
}) {
  const { t } = useTranslation("common");

  return (
    <Layout globals={globals}>
      <Meta
        title={meta?.title || t("publication.title")}
        description={meta?.description || t("publication.description")}
        useTemplate
      />

      <PageHeader
        crumbs={[
          {
            title: "publication.title",
            translate: true,
          },
        ]}
        title={t("publication.title")}
      />

      <section className="relative pt-16 pb-24">
        <div className="relative container mx-auto px-4">
          {nodes?.length ? (
            <NodePublicationList nodes={nodes} />
          ) : (
            <p className="py-4">{t("utils.empty")}</p>
          )}
          {page && (
            <Pager
              current={page.current}
              total={page.total}
              path={t("publication.path")}
            />
          )}
        </div>
      </section>
    </Layout>
  );
}

 async function _getStaticProps(context) {
  const params = new DrupalJsonApiParams();

  params
    .addInclude(["field_image", "field_file"])
    .addPageLimit(NODE_PER_PAGE)
    .addFilter("status", 1)
    .addFilter("langcode", context.locale)
    .addSort("created", "DESC");

  const result = await getResourceCollectionFromContext(
    "node--publication",
    context,
    {
      deserialize: false,
      params: params.getQueryObject(),
    }
  );

  return {
    props: {
      globals: await getGlobals(context),
      meta: await getMeta(LISTS.PUBLICATION, context),
      nodes: deserialize(result),
      page: {
        current: 1,
        total: Math.ceil(result.meta.count / NODE_PER_PAGE),
      },
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/node--publication/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  